import React  from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import {ViewAccess} from "../../../../../../../core/gd/const/views/view-type-config"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"

// @ts-ignore
import SelectUser from "../../../../../../../core/gd-ui/select-user/select-user"
// @ts-ignore
import SelectorInline from "../../../../../../../core/gd-components/selector/inline/selector-inline"
import CustomView from "../../../../../../../core/model2/custom-view/custom-view";

type Props = {
    form        : FormManager
    view        : CustomView
    disabled?   : boolean
}

export default class ViewAccessBlock extends React.Component<Props> {

    onAccessChanged = (value: ViewAccess) => {
        this.props.form.onFormComponentValueChange('access', value)
        this.props.form.setValue('sharedUsers', value === ViewAccess.SHARED ? [] : null)

        this.forceUpdate()
    }

    getCompanyUsers = () => {
        // all company users
        let users = gd.session.companyUsers.filterByCompany(gd.companyId).map((companyUser:any) => companyUser.user)

        // order by name
        users = _.sortBy(users, u => u.name)

        // to array of ids
        users = users.map((u:any) => u.id)

        // remove self
        users = _.filter(users,  id=>id !== gd.session.me.id)
        return users
    }

    render() {

        // views in project structutrre dont have access settings
        if (this.props.view.parentProjectId) {
            return null
        }

        const accessOptions = [
            {id: ViewAccess.PRIVATE,  label: "Private",  icon: 'i5-lock'},
            {id: ViewAccess.SHARED,   label: "Shared",   icon: 'i5-users', disabled: !gd.ac.check.canShareView()}
        ]

        const access = this.props.form.getValue('access')

        return (
            <React.Fragment>
                <div className="row">
                    <div className="label">Access</div>
                    <div className="element">
                        <SelectorInline items={accessOptions}
                                        className="s-36"
                                        selectedId={this.props.form.getValue('access')}
                                        disabled={this.props.disabled}
                                        onChange={this.onAccessChanged} />
                    </div>
                </div>

                {access === ViewAccess.SHARED &&
                <div className="row">
                    <div className="label">Users</div>
                    <div className="element">
                        <SelectUser className   = "w-100-percent"
                                    form        = {this.props.form}
                                    name        = "sharedUsers"
                                    multiselect = {true}
                                    options     = {this.getCompanyUsers()}
                                    renderValue = "form"
                                    placeholder = "Select users"
                                    disabled    = {this.props.disabled}/>

                        <FormError form={this.props.form} name="sharedUsers" />
                    </div>
                </div>}
            </React.Fragment>
        )
    }
}